import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

import { LegendType } from './constants';

function getCssByType(type: LegendType) {
  switch (type) {
    case 'hired':
      return css`
        &::before {
          background: #f8ddc7;
        }
      `;
    case 'left':
      return css`
        &::before {
          background: #87519b;
        }
      `;
    default:
      return css`
        &::before {
          width: 15px;
          height: 3px;
          background: #e27893;
        }
      `;
  }
}

interface LegendProps {
  type: LegendType;
}

export const Wrapper = styled.ul`
  display: flex;
  justify-content: center;
  margin-bottom: 40px;

  ${({ theme }) => theme.media.mobile} {
    margin-top: 20px;
  }
`;

export const Legend = styled.li<LegendProps>`
  display: flex;
  margin-right: 14px;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray800};
  ${getFontStyle('midium120_C1')};

  &::before {
    content: '';
    display: block;
    width: 9px;
    height: 9px;
    margin-right: 7px;
  }

  ${({ theme }) => theme.media.mobile} {
    margin-right: 44px;
  }

  &:last-child {
    margin-right: 0;
  }

  ${({ type }) => getCssByType(type)}
`;
